import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(popupOpenSagaWorker),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(popupOpenSagaWatcher),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(popupCloseSagaWorker),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(popupCloseSagaWatcher),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(popupCloseWithAnswerSagaWorker),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(popupCloseWithAnswerSagaWatcher),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(popupsSaga);

import { all, delay, fork, put, takeLatest } from 'redux-saga/effects';
import { ConstantsUtil } from '@utils';
import { INIT_CLOSE_POPUP, INIT_POPUP_CLOSING_WITH_ANSWER, POPUP_INIT } from './popups.action-types';
import { actions } from './popups.actions';

function popupOpenSagaWorker(action) {
  return _regeneratorRuntime.wrap(function popupOpenSagaWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return put(actions.setPopup({
            popupId: action.payload.popupId,
            isOpen: action.payload.isOpen,
            data: action.payload.data
          }));

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function popupOpenSagaWatcher() {
  return _regeneratorRuntime.wrap(function popupOpenSagaWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return all([takeLatest(POPUP_INIT, popupOpenSagaWorker)]);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function popupCloseSagaWorker(action) {
  return _regeneratorRuntime.wrap(function popupCloseSagaWorker$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return put(actions.popupHide({
            popupId: action.payload.popupId
          }));

        case 2:
          _context3.next = 4;
          return delay(250);

        case 4:
          _context3.next = 6;
          return put(actions.popupClose({
            popupId: action.payload.popupId
          }));

        case 6:
          _context3.next = 8;
          return put({
            type: "".concat(POPUP_INIT, "/").concat(ConstantsUtil.actions.ASYNC_SUCCESS),
            payload: {
              popupId: action.payload.popupId
            }
          });

        case 8:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function popupCloseSagaWatcher() {
  return _regeneratorRuntime.wrap(function popupCloseSagaWatcher$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return all([takeLatest(INIT_CLOSE_POPUP, popupCloseSagaWorker)]);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}

function popupCloseWithAnswerSagaWorker(action) {
  return _regeneratorRuntime.wrap(function popupCloseWithAnswerSagaWorker$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return put(actions.popupHide({
            popupId: action.payload.popupId
          }));

        case 2:
          _context5.next = 4;
          return delay(250);

        case 4:
          _context5.next = 6;
          return put(actions.closeWithAnswer({
            popupId: action.payload.popupId,
            accepted: action.payload.accepted,
            rejected: action.payload.rejected
          }));

        case 6:
          if (!action.payload.accepted) {
            _context5.next = 11;
            break;
          }

          _context5.next = 9;
          return put({
            type: "".concat(POPUP_INIT, "/").concat(ConstantsUtil.actions.ASYNC_SUCCESS),
            payload: {
              popupId: action.payload.popupId,
              accepted: action.payload.accepted,
              rejected: action.payload.rejected
            }
          });

        case 9:
          _context5.next = 13;
          break;

        case 11:
          _context5.next = 13;
          return put({
            type: "".concat(POPUP_INIT, "/").concat(ConstantsUtil.actions.ASYNC_FAILED),
            error: {
              popupId: action.payload.popupId,
              accepted: action.payload.accepted,
              rejected: action.payload.rejected
            }
          });

        case 13:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function popupCloseWithAnswerSagaWatcher() {
  return _regeneratorRuntime.wrap(function popupCloseWithAnswerSagaWatcher$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return all([takeLatest(INIT_POPUP_CLOSING_WITH_ANSWER, popupCloseWithAnswerSagaWorker)]);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

export default function popupsSaga() {
  return _regeneratorRuntime.wrap(function popupsSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return all([fork(popupOpenSagaWatcher), fork(popupCloseSagaWatcher), fork(popupCloseWithAnswerSagaWatcher)]);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}